import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const SHOPSMAPPAGE_LEGACY_FIELD_ORDER = [
  { type: 'separator' },
  "meta_description"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  shopsMapPageDescriptor: _generatedShopsMapPageDescriptor,
  shopsMapPageBlocDefinition,
  shopsMapPageDashboardLayout,
  shopsMapPageConfig,
  shopsMapPageResolveConfig,
  shopsMapPageProperties,
} = doodBlockConfig(
  {
    name: "Shops map page",
    internal_name: "Shops map page",
    url: "map",
    defaultParent: [/^Main Layout$/i],
    componentType: 'ShopsMapPageComponent',
    category: 'page',
    description: "Shops map page.",
    keywords: [],
    isRootBlock: true,
    sharedFields: {}
,
    slots: [
      {
        key: 'body',
        name: "pages.blocks.shops-map-page.body.label",
        accept: 'explicitOnly',
        allowedTypes: [".*(?<!Page)"],
        slotItemFormat: 'ids',
        defaultBlocks: [
          { id: 'header-block', type: 'HeaderBlockComponent' },
          { id: 'shops-map-block', type: 'ShopsMapBlockComponent' },
        ],
      },
      {
        key: 'footer',
        name: "pages.blocks.shops-map-page.footer.label",
        accept: 'explicitOnly',
        allowedTypes: ["BigFooterBlock", "LegalsFooterBlock", "HtmlBlock"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    meta_description: propertyValue({
      type: 'textarea',
      value: '',
      options: {
        label: "pages.blocks.shops-map-page.meta-description.label",
        help: "pages.blocks.shops-map-page.meta-description.help",
        rows: 3,
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.shops-map-page.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.shops-map-page.fieldset.seo.label",
            fields: ["meta_description"],
          },
          {
            legend: "pages.blocks.shops-map-page.fieldset.blocks.label",
            fields: ["body", "footer"],
          },
        ],
      },
    ],
  })
);

export function shopsMapPageDescriptor(): IBlockDescriptor;
export function shopsMapPageDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function shopsMapPageDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedShopsMapPageDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedShopsMapPageDescriptor, shopsMapPageProperties, fieldOrder);
}

export {
  shopsMapPageBlocDefinition,
  shopsMapPageDashboardLayout,
  shopsMapPageProperties,
  shopsMapPageConfig,
  shopsMapPageResolveConfig,
};

export type ShopsMapPageConfig = typeof shopsMapPageConfig;
